import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiSmile, FiTrendingUp, FiShield } from 'react-icons/fi';
import './Outcomes.css';

function Outcomes() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: <FiSmile aria-hidden />,
      titleKey: 'outcomes.customerExperience.title',
      descriptionKey: 'outcomes.customerExperience.description'
    },
    {
      icon: <FiTrendingUp aria-hidden />,
      titleKey: 'outcomes.productivity.title',
      descriptionKey: 'outcomes.productivity.description'
    },
    {
      icon: <FiShield aria-hidden />,
      titleKey: 'outcomes.control.title',
      descriptionKey: 'outcomes.control.description'
    }
  ];

  return (
    <section id="impact" className="outcomes section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('outcomes.title')}</h2>
          <p className="section-quick-answer">{t('outcomes.quickAnswer')}</p>
        </div>

        <div className="outcomes-grid">
          {cards.map((card, index) => (
            <div key={index} className="outcomes-card">
              <div className="outcomes-icon">{card.icon}</div>
              <h3 className="outcomes-card-title">{t(card.titleKey)}</h3>
              <p className="outcomes-card-description">{t(card.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Outcomes;
